import React from 'react';

import { SvgIcon as MuiSvgIcon } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

export interface LogoProps {
  children?: React.ReactNode;
  viewBox?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  svgLogo: {
    color: theme.palette.common.black,
    display: 'block',
    fill: 'none',
    '&.MuiSvgIcon-root': {
      width: '120px',
      height: '36px',
    },
  },
}));

export const SvgLogo = (props: LogoProps): JSX.Element => {
  const { children, viewBox, ...rest } = props;

  const classes = useStyles();

  return (
    <MuiSvgIcon
      aria-hidden="true"
      className={classes.svgLogo}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {children}
    </MuiSvgIcon>
  );
};
